<template>
  <v-lazy><div class="section grey-card fade-in">
    <v-container class="px-10" fluid>
      <v-row justify="center">
        <v-col xl="4" lg="5" md="6" col="12" class="my-auto">
          <div class="enterprise-sms__image-container d-lg my-auto">
            <v-timeline>
            <v-timeline-item class="timeline-container">
              <template v-slot:opposite>
                <v-img
                    src="../assets/img/mms-referral.png"
                    max-width="100"
                    class="ml-auto rounded-xl elevation-6"
                    contain/>
              </template>
              <div class="d-flex timeline-content">
                <div>
                  <strong>MMS</strong>
                  <div class="text-caption">
                    Deliver Referral Letter
                  </div>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item class="timeline-container">
              <template v-slot:opposite>
                <div>
                <div>
                  <strong>SMS AI</strong>
                  <div class="text-caption">
                    Chat with AI Agent about options
                  </div>
                </div>
              </div>
                
              </template>
              <div class="d-flex timeline-content">
                <v-img
                    src="../assets/img/sms-convo.png"
                    aspect-ratio="1"
                    cover
                    style="background-color: white;"
                    max-width="100"
                    class="ml-auto rounded-xl elevation-6"
                    contain/>
              </div>
              
            </v-timeline-item>

            <v-timeline-item class="timeline-container">
              <template v-slot:opposite>
                <v-img
                    src="../assets/img/ai-chat.jpg"
                    aspect-ratio="1"
                    cover
                    style="background-color: white;"
                    max-width="100"
                    class="ml-auto rounded-xl elevation-6"
                    contain/>
              </template>
              <div class="d-flex timeline-content">
                <div>
                  <strong>Voice AI</strong>
                  <div class="text-caption">
                    Call-me service for ID&V
                  </div>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item class="timeline-container">
              <template v-slot:opposite>
                <div>
                <div>
                  <strong>Human Agent</strong>
                  <div class="text-caption">
                    Discuss account and payment arrangement
                  </div>
                </div>
              </div>
                
              </template>
              <div class="d-flex timeline-content">
                <v-img
                    src="../assets/img/voice-chat.jpg"
                    aspect-ratio="1"
                    cover
                    style="background-color: white;"
                    max-width="100"
                    class="ml-auto rounded-xl elevation-6"
                    contain/>
              </div>
              
            </v-timeline-item>
            <v-timeline-item class="timeline-container">
              <template v-slot:opposite>
                <v-img
                    src="../assets/img/sms-convo.png"
                    aspect-ratio="1"
                    cover
                    style="background-color: white;"
                    max-width="100"
                    class="ml-auto rounded-xl elevation-6"
                    contain/>
              </template>
              <div class="d-flex timeline-content">
                <div>
                  <strong>SMS AI</strong>
                  <div class="text-caption">
                  Link to payment gateway to reduce PCI requirements
                  </div>
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
          </div>
        </v-col>
        <v-col xl="5" lg="6" md="6" cols="12">
          <h2 class="section__header-title mb-15">Multi-medium Engagement</h2>
            <v-card class="mb-15">
                <v-card-title>AI Context Analysis</v-card-title>
                <v-card-text>Use our AI decision engines to classify outcomes and move customers between stages.</v-card-text>
            </v-card>
            <v-card class="mb-15">
                <v-card-title>Journey Automation</v-card-title>
                <v-card-text>Build journeys that give customers confidence and lead to consistent conversion.</v-card-text>
            </v-card>
            <v-card class="mb-15">
                <v-card-title>Seamless Transitions</v-card-title>
                <v-card-text>Empower customers by providing a range of mediums for engagement, allowing them to seamlessly move between SMS, voice calls and online channels.</v-card-text>
            </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div></v-lazy>
</template>
<script>
export default {
    name: 'CollectionsEngagement',
}
</script>

<style lang="scss">

.timeline-container {
  position: relative; 
  height: 10em;
}
.timeline-content {
  height: 100%; 
  align-items: center;
}

</style>